module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./LogisticsInfoView.js"));
	}, "LogisticsInfoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LogisticsInfoView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/LogisticsInfo/LogisticsInfoView.js
// module id = 1039
// module chunks = 438